import { render, staticRenderFns } from "./MisPatologias.vue?vue&type=template&id=4476bf17&scoped=true&lang=pug"
import script from "./MisPatologias.vue?vue&type=script&lang=js"
export * from "./MisPatologias.vue?vue&type=script&lang=js"
import style0 from "./MisPatologias.vue?vue&type=style&index=0&id=4476bf17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476bf17",
  null
  
)

export default component.exports